import { AreaOfInterestEnum } from '../enums/area-of-interest-enum';

/**
 * Códigos de capa del endpoint /layers/monitoring utilizados para localizar los
 * servicios que se consultan cuando el usuario ingresa un código/número en un
 * Área de Interés. Los campos de filtro no se definen aquí: se descubren desde
 * la metadata de cada servicio en la capa de infraestructura.
 */
export class AreaOfInterestConstant {
  static readonly LAYER_CODES: Record<AreaOfInterestEnum, string[]> = {
    [AreaOfInterestEnum.AuthorizationTitle]: ['L0011', 'L0016', 'L0028'],
    [AreaOfInterestEnum.ManagementPlan]: ['L0017'],
    [AreaOfInterestEnum.ConservationPlan]: ['L0024'],
    [AreaOfInterestEnum.Coordinates]: [],
    [AreaOfInterestEnum.Shapefile]: [],
    [AreaOfInterestEnum.GeoJson]: [],
    [AreaOfInterestEnum.DrawPolygon]: [],
  };
}